/* eslint-disable @typescript-eslint/no-empty-function */

import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "circ-nav",
    templateUrl: "./nav.component.html",
    styleUrls: ["./nav.component.scss"],
    standalone: false
})
export class NavComponent {
  @Input() expanded = true;
  @Input() isAdmin = true;
  @Input() drawerMode: string;
  @Output() navClick = new EventEmitter<string>();

  public substituteLinks = [
    {
      emitValue: "toAdminSubstitutes",
      title: "menu.nav.admin.substitutes.text",
      text: "menu.nav.admin.substitutes.text"
    }
  ];

  public adminLinks = [
    {
      emitValue: "toAdminUsers",
      title: "menu.nav.admin.users.text",
      text: "menu.nav.admin.users.text"
    },
    {
      emitValue: "toAdminRoles",
      title: "menu.nav.admin.roles.text",
      text: "menu.nav.admin.roles.text"
    },
    {
      emitValue: "toAdminDashboard",
      title: "menu_nav_admin_circulations_text",
      text: "menu_nav_admin_circulations_text"
    },
    {
      emitValue: "toBackgroundJobs",
      title: "menu.nav.admin.jobs.text",
      text: "menu.nav.admin.jobs.text"
    },
    {
      emitValue: "toAdminSettings",
      title: "menu_nav_admin_settings_text",
      text: "menu_nav_admin_settings_text"
    }
  ];
}
